import { render, staticRenderFns } from "./PupilsListSelect.vue?vue&type=template&id=158d7463&scoped=true&"
import script from "./PupilsListSelect.vue?vue&type=script&lang=js&"
export * from "./PupilsListSelect.vue?vue&type=script&lang=js&"
import style0 from "./PupilsListSelect.vue?vue&type=style&index=0&id=158d7463&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158d7463",
  null
  
)

export default component.exports